import {Box, Heading, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr} from '@chakra-ui/react';
import React from 'react';
import {CensusForLeaderDTO} from "../../model/censusForLeaderDTO";
import RegistrationStateBadge from "./RegistrationStateBadge";
import {RegistrationStateText} from "../../model/census";

interface LeaderCensusesSummaryProps {
    leaderCensuses: CensusForLeaderDTO[];
}

const LeaderCensusesSummary: React.FC<LeaderCensusesSummaryProps> = (props) => {
    return (
        <Box
            pt="89px"
            minWidth="55%"
        >
            <TableContainer p="34">
                <Heading p="5" as="h3" size="md" textAlign="start">Wnioski z twojej jednostki</Heading>
                <Table size='md'>
                    <Thead>
                        <Tr>
                            <Th>Status wniosku</Th>
                            <Th>Liczba</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {Object.entries(props.leaderCensuses.reduce((group: { [key: string]: CensusForLeaderDTO[] }, item) => {
                            if (!group[item.RegistrationState]) {
                                group[item.RegistrationState] = [];
                            }
                            group[item.RegistrationState].push(item);
                            return group;
                        }, {})).map(([state, census]) => (
                            <Tr key={state}>
                                <Td><RegistrationStateBadge registrationState={RegistrationStateText[parseInt(state)] || 'błędny stan'} /></Td>
                                <Td>{census.length}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default LeaderCensusesSummary;